var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "noticeDetail" }, [
    _c("div", { staticClass: "noticeDetailBox" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/img/notice/img_yichehui.png"),
          alt: "通知已撤回",
        },
      }),
      _c("div", { staticClass: "boxText" }, [_vm._v("通知已被撤回")]),
      _c(
        "button",
        {
          on: {
            click: function ($event) {
              return _vm.$router.push("/notice")
            },
          },
        },
        [_vm._v("返回通知列表")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }